import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { BiMenuAltLeft } from "react-icons/bi";
import { RiCloseFill } from "react-icons/ri";
// style sheets
import "../css/dashboard.css";
import { SidebarContext } from "../contexts/SidebarContext";

const Dashboard = ({ children }) => {
  const [sidebar, setSidebar] = useState(false);
  // let navigate = useNavigate();
  // useEffect(() => {
  //   navigate("/home", { replace: true });
  // }, [navigate]);
  useEffect(() => {
    if (sidebar) {
      document.querySelector(".dashboard").classList.add("open");
      document.querySelector(".dashboard").classList.remove("close");
    } else {
      document.querySelector(".dashboard").classList.add("close");
      document.querySelector(".dashboard").classList.remove("open");
    }
  }, [sidebar]);
  return (
    <SidebarContext.Provider value={{ sidebar, setSidebar }}>
      <main className="dashboard open">
        <Sidebar setSidebar={setSidebar} />
        <BiMenuAltLeft className="open-menu" onClick={() => setSidebar(true)} />
        <div className="close-menu" onClick={() => setSidebar(false)}>
          <RiCloseFill />
        </div>
        {children}
      </main>
    </SidebarContext.Provider>
  );
};

export default Dashboard;
